/**
 * The configured API client. Import SDK functions and query options from
 * "@/api" (re-exported below), never from "./generated" directly, so this
 * module's setup (error wrapping) is always applied first.
 */

import { ApiError, retryAfterSeconds } from "./errors";
import { client } from "./generated/client.gen";

client.interceptors.error.use((error, response) => {
  if (error instanceof ApiError) return error;
  // No response = network failure or request-building error.
  if (!response) return new ApiError(0, error instanceof Error ? error.message : "Network error", error);
  return new ApiError(
    response.status,
    response.statusText,
    error,
    response.headers.get("x-request-id"),
    retryAfterSeconds(response.headers),
  );
});

export { client };
